module.exports = __webpack_public_path__ + "static/media/favicon-gp.ba73f760.png";